import React from 'react'

import { BrowserRouter, useLocation, useNavigate, useParams } from 'react-router-dom'
import { StaticRouter } from 'react-router-dom/server'

import PropTypes from 'prop-types'

export { useLocation, useNavigate, useParams }

// Opt into the v7 behaviours now so react-router stops logging its future-flag
// warnings on every page load. Every Link/navigate target in the app is absolute,
// so the splat-path change has no effect on resolved URLs.
const ROUTER_FUTURE = { v7_startTransition: true, v7_relativeSplatPath: true }

function ContextBasedRouter({ children, basename = '/', initialPathname = '' }) {
  if (typeof window === 'undefined') {
    return (
      <StaticRouter basename={basename} location={initialPathname} future={ROUTER_FUTURE}>
        {children}
      </StaticRouter>
    )
  }

  return (
    <BrowserRouter basename={basename} future={ROUTER_FUTURE}>
      {children}
    </BrowserRouter>
  )
}

ContextBasedRouter.propTypes = {
  children: PropTypes.node.isRequired,
  basename: PropTypes.string,
  initialPathname: PropTypes.string,
}

export default ContextBasedRouter
